import React from 'react';
import styled from 'styled-components';

const GatdaProject = () => {
  return (
    <Container>
      <div className='box'>
        <div className='box-tag'>관리자 페이지</div>
        <div className='box-heading'>
          업무를 편하게.
          <br />
          어드민 페이지는 필수.
        </div>
        <div className='box-detail'>
          <div className='box-desc-heading'>
            <div className='box-desc-list'>
              <div className='box-desc-list-item'>온라인 파트너쉽 자동화</div>
              <div className='box-desc-list-item'>서비스 신청 관리</div>
              <div className='box-desc-list-item'>
                이벤트 당첨 및 당첨자 관리
              </div>
              <div className='box-desc-list-item'>Crawling 데이터 관리</div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  grid-column: span 2;

  .img-box {
    text-align: center;

    img {
      width: 540px;
    }
  }

  .box {
    background: linear-gradient(
      229deg,
      #517281 0%,
      #3b5d70 27%,
      #4d5c82 72%,
      #5d647f 100%
    );
    border-radius: 25px;
    text-align: left;
    padding: 40px;
  }

  .box-tag {
    margin-bottom: 40px;
    color: #fff;
    font-size: 19px;
    font-weight: 600;
  }

  .box-heading {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-sub-heading {
    font-size: 64px;
    font-weight: 700;
    margin: 0;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-detail {
    font-size: 19px;

    .box-desc-heading {
      color: #fff;
      margin-bottom: 8px;
    }

    .box-description {
      margin: 0;
    }

    .box-desc-list {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 48px;
      font-size: 36px;
      font-weight: 700;

      .box-desc-list-item {
        padding: 12px 18px;
        text-align: center;
      }
    }
  }

  @media only screen and (min-width: 769px) {
    .box-detail {
      .box-desc-list {
        font-size: 56px;
      }
    }
  }
`;

export default GatdaProject;
